import { useState } from 'react';
import { Button, Card, Container, Form } from 'react-bootstrap';

const Auth = ({ authOK }) => {
    const [nom, setNom] = useState('');
    const [motDePasse, setMotDePasse] = useState('');

    const url = localStorage.getItem('url');

    const handleSubmit = async (e) => {
        e.preventDefault();
        fetch(`${url}Auth/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ nom, motDePasse }),
        })
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0')
                    alert('Erreur de connexion');
                else {
                    localStorage.setItem('code', data.sessioncode);
                    authOK(data.sessioncode);
                }
            })
            .catch(error => {
                console.error('Erreur lors de la requête:', error);

                //get code from localstorage
                let code = localStorage.getItem('code');
            });

    };

    return (
        <>
            {/* <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formIdentifiant">
                    <Form.Label>Identifiant :</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Entrez votre identifiant"
                        value={nom}
                        onChange={(e) => setNom(e.target.value)}
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formMotDePasse">
                    <Form.Label>Mot de passe :</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Entrez votre mot de passe"
                        value={motDePasse}
                        onChange={(e) => setMotDePasse(e.target.value)}
                    />
                </Form.Group>

                <Button variant="primary" type="submit">
                    Connexion
                </Button>
            </Form> */}

            <Container className="text-center">
                <Card>
                    <Card.Body>
                        <h5 className="card-title">Connectez-vous</h5>
                        <Form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="col-12">
                                    <Form.Control
                                        type="text"
                                        placeholder="Identifiant"
                                        value={nom}
                                        onChange={(e) => setNom(e.target.value)}
                                        required
                                    />
                                </div><br></br>
                                <div className="col-12">
                                    <Form.Control
                                        type="password"
                                        placeholder="Mot de passe"
                                        value={motDePasse}
                                        onChange={(e) => setMotDePasse(e.target.value)}
                                        required
                                    />
                                </div>
                                {/* <div hidden={!isWrong} className="col-12">
                                    <h4 style={{ color: 'red' }}>Votre identifiant et/ou votre mot de passe sont erronés</h4>
                                </div>
                                <div hidden={!isFirewall} className="col-12">
                                    <h4 style={{ color: 'red' }}>Vous n'êtes pas connecté à internet</h4><br />
                                    <p>Si vous êtes connecté à internet, alors votre service informatique bloque le site</p>
                                    <p>Merci de leur demander de mettre sur la liste blanche des sites autorisés l'url suivante :</p>
                                    <p>https://webservices.k-lix.com/</p>
                                </div> */}
                            </div>
                            <br />
                            <Button variant="primary" type="submit">
                                Connexion
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default Auth;
